<template>
  <nav class="navbar is-fixed-top">
    <div class="columns is-vcentered is-marginless">
      <router-link
        to="/"
        class="column is-2 is-paddingless"
        aria-label="Home"
        v-if="$store.state.logo_uri"
      >
        <img
          class="logo"
          :src="$store.state.logo_uri"
          alt="Directory Hero"
          v-on:click="searchStore.query = ''"
        >
      </router-link>
      <div class="is-divider-vertical is-hidden-mobile"></div>
      <div id="directorySelector" class="column is-narrow is-paddingless is-hidden-mobile">
        <div class="select is-fullwidth">
          <select name="section" @change="navigateDirectory">
            <option>I'm looking for...</option>
            <option
              v-for="directory in $store.getters.directories"
              :key="directory.id"
              :selected="$route.params.directory.toLowerCase() == directory.slug.toLowerCase()"
              :value="directory.slug"
            >{{ directory.name }}</option>
          </select>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <p class="control has-icons-left">
            <ais-search-box
              :class-names="{
                'ais-input': 'input searchBox',
                'ais-search-box__form': 'form',
                'ais-search-box__submit': 'is-hidden',
                'ais-clear': 'is-hidden',
              }"
              :placeholder="`Search ${currentDirectory} by Name, ${facets.join(', ')}`"
              aria-label="Search"
              autofocus
            ></ais-search-box>
            <span class="icon has-text-grey is-left">
              <fa icon="search"></fa>
            </span>
          </p>
        </div>
      </div>
      <div class="column"></div>
      <div
        class="column is-3 has-text-right is-header-ad"
        v-if="$store.state.header_ad_image && $store.state.header_ad_link"
      >
        <a :href="$store.state.header_ad_link">
          <img :src="$store.state.header_ad_image" alt="Advertisement">
        </a>
      </div>
    </div>
    <div
      id="facet-nav"
      class="columns is-vcentered is-marginless is-hidden-mobile"
      v-if="!$route.params.record"
    >
      <div class="column is-10 is-paddingless">
        <FacetNav></FacetNav>
      </div>
      <div class="column is-2 has-text-right">
        <span class="is-italic is-hidden-mobile">
          {{ (searchStore.page - 1) * searchStore.resultsPerPage }} -
          {{ ((searchStore.page - 1) * searchStore.resultsPerPage)
            + searchStore.results.length }}
        </span>
        <span class="is-hidden-mobile"> of </span>
        <span> {{ searchStore.totalResults }} Results</span>
      </div>
    </div>
  </nav>
</template>

<script>
/* eslint-disable import/no-unresolved */
import FacetNav from '@/components/FacetNav.vue';
import { Component } from 'vue-instantsearch';

export default {
  mixins: [Component],
  data() {
    return {
      currentDirectory: this.$store.state.directories[this.$route.params.directory].name,
    };
  },
  computed: {
    facets() {
      return this.$store.getters.facets(this.$route.params.directory).map(facet => facet.name);
    },
    queryParameters() { return this.searchStore.queryParameters; },
  },
  methods: {
    navigateDirectory(e) {
      // Reset the search parameters for Algolia
      this.searchStore.query = '';
      this.searchStore.clearRefinements();
      this.$emit('resetPageCount');

      // Redirect the user to the new URL
      this.$router.push(`/${e.target.value.toLowerCase()}`);

      // Set the search bar placeholder to have the correct directory name
      this.currentDirectory = e.target.selectedOptions[0].text;
    },
  },
  watch: {
    queryParameters(query, oldQuery) {
      if (query.query === oldQuery.query) return;
      this.$router.push({
        name: 'directory',
        query: { query: query.query },
      });
    },
  },
  components: {
    FacetNav,
  },
};
</script>
